import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Link } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import Callout from 'modules/core/components/Callout'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

interface Props {
  attendanceSetting: AttendanceSetting
}

const TimeOffSettingsCallout = ({ attendanceSetting }: Props) => {
  const [hasSeenCallout, setHasSeenCallout] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideTimeOffConditionsCallout,
    false
  )
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  if (hasSeenCallout) return null

  const routeParams = {
    id: 'time_tracking',
    settingId: attendanceSetting.id.toString(),
    tabId: 'compensation',
  }

  return (
    <Callout
      type="info"
      title={i18n.t(
        'time_tracking.settings.work_time_categories.extra_hours_rules.time_off_settings_callout.title'
      )}
      description={i18n.t(
        'time_tracking.settings.work_time_categories.extra_hours_rules.time_off_settings_callout.description'
      )}
      onRemove={() => {
        setHasSeenCallout(true)
      }}
      action={
        <Link.Touchable
          title={i18n.t(
            'time_tracking.settings.work_time_categories.extra_hours_rules.time_off_settings_callout.link'
          )}
          type="solid"
          onClick={() => {
            track(trackingEvents.timeTracking.callOutTimeOffSettingsLinkPressed)
            navigate(navigation.settings.time_tracking.settingId.tabId.fullPath(routeParams))
          }}
        >
          {i18n.t(
            'time_tracking.settings.work_time_categories.extra_hours_rules.time_off_settings_callout.link'
          )}
        </Link.Touchable>
      }
    />
  )
}

export default TimeOffSettingsCallout
